import shopData from '../../assetsPath/shop.data';

/*this value needs not to be changed */
const shopDataReducer = (state = shopData) => state;

export default shopDataReducer;